/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row align-start wrap fill-height>
    <v-flex xs12 md9>
      <Graph :fullDate="fullDate" />
    </v-flex>
    <v-flex xs12 md3>
      <SideCard @activeBlock="(val) => blockId = val" />
    </v-flex>
  </v-layout>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import {
  mixin,
  filterMixin,
  mapGettersMixin
} from '@/util/mixin/index'
import 'element-ui/lib/theme-chalk/index.css'

const Graph = () => import('@/components/dashboard-inverter/Graph')
const SideCard = () => import('@/components/dashboard-inverter/SideCard')

// TODO: Map redirect have to be handled
export default {
  mixins: [ mixin, filterMixin, mapGettersMixin ],
  components: {
    Graph,
    SideCard
  },
  data() {
    return {
      blockId: null
    }
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    fullDate() {
      return [this.activeFilter.Date.from, this.activeFilter.Date.to]
    }
  },
  beforeDestroy() {
    this.SET_MAP_REDIRECT_BLOCK(false)
  },
  methods: {
    ...mapMutations(['SET_MAP_REDIRECT_BLOCK'])
  }
}
</script>

<style scoped>
@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.main-background {
  background-color: #2a335a;
}

.theme--dark {
  width: -webkit-fill-available;
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .v-card {
    width: 200px !important;
  }
}

</style>

<style>
@media only screen and (min-width: 320px) and (max-width: 960px) {
  .ag-energy .v-btn-toggle .v-btn {
    padding: 0px 38px !important;
  }

  .ag-blockcolor,
  .ag-energy .v-btn-toggle {
    border-radius: 10px !important;
    border: 1px solid #000 !important;
  }

  .ag-sub-header {
    height: 50px !important;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  #daily-updates>.v-card {
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .ag-priority>.v-input__control>.v-input__slot {
    /* background-color: #fff !important; */
    border: 1px solid;
    border-radius: 10px !important;
    padding: 15px !important;
  }

  .v-select__selection--comma,
  .v-select .v-label {
    font-size: 13px !important;
  }

  .ag-priority {
    width: 125px !important;
  }

  .ag-plant-overview {
    padding-top: 15px !important;
  }

  .ag-graph {
    padding: 16px 5px !important;
  }

  .ag-room,
  .ag-energy {
    text-align: center;
  }

  .ag-room .v-btn-toggle {
    border: 1px solid;
    border-radius: 10px;
    /* background-color: #FFF !important; */
  }

  .ag-room .v-btn-toggle .v-btn:first-child,
  .ag-energy .v-btn-toggle .v-btn:first-child {
    border-radius: 8px 0 0 8px;
  }

  .ag-room .v-btn-toggle .v-btn:last-child,
  .ag-energy .v-btn-toggle .v-btn:last-child {
    border-radius: 0 9px 9px 0;
  }

  .ag-room .v-btn-toggle .v-btn,
  .ag-energy .v-btn-toggle .v-btn {
    padding: 0px 40px !important;
    /* color: #000 !important; */
  }

  .ag-energy .mt-2 {
    border: 8px;
  }

  .block-content {
    /* background-color: #FFF !important; */
    padding: 16px 10px;
  }

  .theme--dark .activeBlock,
  .block-content .v-list {
    border-radius: 10px !important;
  }

  #e3 .sub-header,
  #e3 {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  #e3 .sub-header .v-toolbar__content,
  .ag-block-color,
  .ag-sub-header .v-toolbar__title {
    /* color: #fff !important; */
  }

  .single-card .hoverable {
    border: none !important;
  }

  .floating-btn {
    margin-top: 30px;
  }

  .ag-graph .layout .flex {
    padding: 4px !important;
  }

  .ag-picker .v-picker__title .v-date-picker-title,
  .v-date-picker-title {
    color: #000 !important;
    align-items: center !important;
  }

  .activeBlock {
    margin: 10px;
  }

  .notActive {
    margin: 10px;
    border-radius: 10px;
  }

  .ana-card {
    padding: 20px 12px !important;
  }
}
</style>
